import axios, { AxiosRequestConfig } from 'axios';
import { NavigateFunction } from 'react-router-dom';
import { clearSessionCredentials } from '../globalFunctions';
import { School } from '../types';

export class SchoolDAO {
    static async save(token: string, navigate: NavigateFunction, school: School) {
        if (school.id > 0) {
            return await SchoolDAO.update(token, navigate, school);
        } else {
            return await SchoolDAO.store(token, navigate, school);
        }
    }

    static async store(token: string, navigate: NavigateFunction, school: School) {
        try {
            const requestConfig: AxiosRequestConfig = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: `Bearer ${token}`,
                    Accept: 'application/json'
                }
            };

            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/school`,
                school,
                requestConfig
            );

            return response.data;
        } catch (error: any) {
            const response = {
                message: 'Erro ao criar escola',
                error: error
            };

            if ([401, 419].includes(error.response.status)) {
                // Unauthorized
                clearSessionCredentials(navigate);
            } else {
                console.error(response);
                return response;
            }
        }
    }

    static async update(token: string, navigate: NavigateFunction, school: School) {
        try {
            const requestConfig: AxiosRequestConfig = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: `Bearer ${token}`,
                    Accept: 'application/json'
                }
            };

            const response = await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/school/${school.id}`,
                school,
                requestConfig
            );

            return response.data;
        } catch (error: any) {
            const response = {
                message: 'Erro ao atualizar escola',
                error: error
            };

            if ([401, 419].includes(error.response.status)) {
                // Unauthorized
                clearSessionCredentials(navigate);
            } else {
                console.error(response);
                return response;
            }
        }
    }

    static async restore(token: string, navigate: NavigateFunction, id: number) {
        try {
            const requestConfig: AxiosRequestConfig = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: `Bearer ${token}`,
                    Accept: 'application/json'
                }
            };

            const response = await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/school/${id}/restore`,
                {},
                requestConfig
            );

            return response.data;
        } catch (error: any) {
            const response = {
                message: 'Erro ao restaurar escola',
                error: error
            };

            if ([401, 419].includes(error.response.status)) {
                // Unauthorized
                clearSessionCredentials(navigate);
            } else {
                console.error(response);
                return response;
            }
        }
    }

    static async delete(token: string, navigate: NavigateFunction, id: number) {
        try {
            const requestConfig: AxiosRequestConfig = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: `Bearer ${token}`,
                    Accept: 'application/json'
                }
            };

            const response = await axios.delete(
                `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/school/${id}`,
                requestConfig
            );

            return response.data === 1;
        } catch (error: any) {
            const response = {
                message: 'Erro ao excluir escola',
                error: error
            };

            if ([401, 419].includes(error.response.status)) {
                // Unauthorized
                clearSessionCredentials(navigate);
            } else {
                console.error(response);
                return response;
            }
        }
    }
}
